import React from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { UploadIcon } from '@/atoms/Icons/UploadIcon'
import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'
import { GButtonMD } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'

interface Props {
  onClick: () => void
  className?: string
}

export const FloatingShareButton: React.FC<Props> = ({ onClick, className }) => {
  const { t } = useTranslate('tickets')
  const { theatricalSlug } = useGiveawayContext()

  const isNewDesign = theatricalSlug === slugs.david

  if (isNewDesign) {
    return (
      <motion.button
        initial={{ y: 100, opacity: 0 }}
        animate={{
          y: 0,
          opacity: 1,
          transition: { type: 'tween', duration: 0.3 },
        }}
        onClick={onClick}
        className={classNames(
          'bg-giveaway-secondary-accent-dark p-4 px-6 drop-shadow-md fixed flex flex-col gap-6 right-[1.5rem] z-50 rounded-xl',
          className,
        )}
      >
        <div className="flex items-center gap-1">
          <div className="flex flex-col">
            <GButtonMD color="giveaway-background-primary-light">{t('share', 'Share')}</GButtonMD>
          </div>
          <UploadIcon size={28} color="giveaway-background-primary-light" />
        </div>
      </motion.button>
    )
  }

  return (
    <motion.button
      initial={{ y: 100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: { type: 'tween', duration: 0.3 },
      }}
      onClick={onClick}
      className={classNames(
        'bg-giveaway-primary-subtle-dark p-[14px] px-6 drop-shadow-md fixed flex flex-col gap-6 right-[1.5rem] z-50',
        theatricalSlug === slugs.sketch ? 'rounded-none' : 'rounded-xl',
        theatricalSlug === slugs.senior && '!bg-giveaway-primary-subtle-light',
        theatricalSlug === slugs.soloMio && '!bg-giveaway-secondary-accent',
        className,
      )}
    >
      <div className="flex items-center gap-1">
        <div className="flex flex-col">
          <GButtonMD color={theatricalSlug === slugs.senior ? 'giveaway-text-primary-dark' : 'giveaway-primary'}>
            {t('share', 'Share')}
          </GButtonMD>
        </div>
        <UploadIcon
          size={28}
          color={theatricalSlug === slugs.senior ? 'giveaway-text-primary-dark' : 'giveaway-primary'}
        />
      </div>
    </motion.button>
  )
}
